@if (inlineAlerts) {
  @if (alerts && alerts.length) {
    <h3 class="mb-4">{{'ALERTS'|translate}}</h3>
  }
  <!-- <app-preorder-alert></app-preorder-alert> -->
  @for (alert of alerts; track alert) {
    <app-alert-item [alert]="alert" class="d-block clickable withOpacity" (showNews)="showNewsItem($event)"
      [isPreview]="isPreview">
    </app-alert-item>
  }
} @else {
  <div class="p-3">
    @if (alerts && alerts.length) {
      <h4 class="mb-4">{{'ALERTS'|translate}}</h4>
    }
    @for (alert of alerts; track alert) {
      <app-alert-item [alert]="alert" class="d-block clickable withOpacity" (showNews)="showNewsItem($event)"
        [isPreview]="isPreview">
      </app-alert-item>
    }
  </div>
}

